<template>
  <div class="pb-4">
    <v-layout row justify-end>
      <v-flex xs12 sm6 md3 xs-off>
        <v-text-field
          v-model="searchText"
          :append-outer-icon="'search'"
          label="Wpisz szukaną frazę"
          clearable
          @click:clear="clearSearch"
          @click:append-outer="searchClient"
          v-on:keyup.enter="searchClient"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'client-search',
  data: () => ({
    searchText: null,
  }),
  computed: {
    ...mapGetters('clients', [
      'query',
    ]),
  },
  methods: {
    searchClient() {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      if (this.searchText) {
        newQuery.search = this.searchText;
        this.$router.push({ path: '/klienci/1', query: newQuery });
      } else {
        this.clearSearch();
      }
    },
    clearSearch() {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      delete newQuery.search;
      this.$router.push({ path: '/klienci/1', query: newQuery });
    },
  },
  mounted() {
    const { query } = this.$route;
    this.searchText = query.search;
  },
};
</script>
